// extracted by mini-css-extract-plugin
export default {"sent":"a64e12b0d00f"};